import { createSelector } from 'reselect'
import { selectAccount } from './selectAccount'

export const selectAccountId = createSelector(
  selectAccount,
  account => account.id
)
